import { getCDNImageURL } from "@punchup/utils/getCDNImageURL";

/**
 * The Tixologi event endpoint sometimes resolves to the string "event not
 * found" instead of an event object, so narrow at runtime before reading
 * `images` rather than asserting a shape onto what might be a string.
 */
export function tixologiEventImageUrl(event: unknown): string | null {
  if (!event || typeof event !== "object" || !("images" in event)) return null;
  const { images } = event as { images?: Array<{ image?: string }> };
  return images?.[0]?.image ?? null;
}

/**
 * A show's poster on the venue page: the Tixologi event's promo image when the
 * show is ticketed there, else the Cloudflare poster stored on the show itself.
 */
export function showPosterUrl(
  show: { tixologi_event_id: string | null; poster_img: string | null },
  tixologiEvent: unknown
): string | null {
  const tixologiImage = show.tixologi_event_id
    ? tixologiEventImageUrl(tixologiEvent)
    : null;
  if (tixologiImage) return tixologiImage;
  return show.poster_img ? getCDNImageURL(show.poster_img) : null;
}
